export default __webpack_public_path__ + "static/media/logoForInvoice.2df9635e.jpeg";